var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirTempControl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 1.66699H14.3327",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6673 5.66732H14.0007V7.00065H15.0007C15.1775 7.00065 15.347 6.93041 15.4721 6.80539C15.5971 6.68036 15.6673 6.5108 15.6673 6.33398V1.00065C15.6673 0.82384 15.5971 0.654271 15.4721 0.529247C15.347 0.404222 15.1775 0.333984 15.0007 0.333984H1.00065C0.82384 0.333984 0.654271 0.404222 0.529247 0.529247C0.404222 0.654271 0.333984 0.82384 0.333984 1.00065V6.33398C0.333984 6.5108 0.404222 6.68036 0.529247 6.80539C0.654271 6.93041 0.82384 7.00065 1.00065 7.00065H2.00065V5.66732H10.0007",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7.00098H10",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4.33398H9",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.335 14.0011C11.7035 14.0011 12.0021 13.7025 12.0021 13.3341C12.0021 12.9657 11.7035 12.667 11.335 12.667C10.9666 12.667 10.668 12.9657 10.668 13.3341C10.668 13.7025 10.9666 14.0011 11.335 14.0011Z",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.332 6.66699V12.667",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 4.33431C12.6667 3.98069 12.5262 3.64155 12.2761 3.3915C12.0261 3.14145 11.687 3.00098 11.3333 3.00098C10.9797 3.00098 10.6406 3.14145 10.3905 3.3915C10.1405 3.64155 10 3.98069 10 4.33431V11.421C9.59234 11.7048 9.28591 12.1114 9.12531 12.5815C8.96471 13.0515 8.95832 13.5606 9.10708 14.0346C9.25583 14.5085 9.55197 14.9226 9.95238 15.2166C10.3528 15.5106 10.8366 15.6692 11.3333 15.6692C11.8301 15.6692 12.3139 15.5106 12.7143 15.2166C13.1147 14.9226 13.4108 14.5085 13.5596 14.0346C13.7083 13.5606 13.702 13.0515 13.5414 12.5815C13.3808 12.1114 13.0743 11.7048 12.6667 11.421V4.33431Z",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66797 12.334V13.6673H3.66797L5.33464 15.334L7.0013 13.6673H6.0013V12.334",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66797 11.334V10.0007H3.66797L5.33464 8.33398L7.0013 10.0007H6.0013V11.334",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirTempControl);
export default __webpack_public_path__ + "static/media/airTempControl.dc444cb1.svg";
export { ForwardRef as ReactComponent };